/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSchedulerSuggestedTime_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly " $refType": "EventSchedulerSuggestedTime_org";
};
export type EventSchedulerSuggestedTime_org$data = EventSchedulerSuggestedTime_org;
export type EventSchedulerSuggestedTime_org$key = {
    readonly " $data"?: EventSchedulerSuggestedTime_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSchedulerSuggestedTime_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSchedulerSuggestedTime_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "experiments",
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '5b134abde2f75d339c7bec41494addf7';
export default node;
